module.exports = __webpack_public_path__ + "img/6_104.cd304f3f.png";